import React, { useState, useEffect } from 'react';
import './admin.css';

const AdminPage = () => {
  // State to store employee credentials and form data
  const [empId, setEmpId] = useState('');
  const [empName, setEmpName] = useState('');
  const [designation, setDesignation] = useState('');
  const [city, setCity] = useState('');
  const [fuelRate, setFuelRate] = useState('');
  const [fuelType, setFuelType] = useState('');
  const [expenseCategory, setExpenseCategory] = useState('');
  const [message, setMessage] = useState('');

  // Fetch employee details from localStorage
  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    if (storedEmpId && storedEmpName && storedDesignation) {
      setEmpId(storedEmpId);
      setEmpName(storedEmpName);
      setDesignation(storedDesignation);
    } else {
      alert('Session expired. Please log in again.');
      window.location.href = '/login'; // Redirect to login if not logged in
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update state dynamically based on input field name
    if (name === 'city') setCity(value);
    else if (name === 'fuelRate') setFuelRate(value);
    else if (name === 'fuelType') setFuelType(value);
    else if (name === 'expenseCategory') setExpenseCategory(value);
  };

  const handleEmployeeSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields (fuelRate and expenseCategory)
    if (!fuelRate || !expenseCategory) {
      setMessage({ text: 'Please fill in all required fields.', type: 'error' });
      return;
    }

    // Prepare the data to be sent to the backend
    const employeeData = {
      empId,
      empName,
      designation,
      expenseCategory,
      city: city || null,  // Send null if city is not selected
      fuelRate: fuelRate || null,  // Send null if fuel rate is not entered
      fuelType: fuelType || null,  // Send null if fuel type is not selected
    };

    try {
      const response = await fetch('https://cleezoclass.com:8443/api/expense', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(employeeData),   
      });

      if (response.ok) {
        const data = await response.json();
        setMessage({ text: 'Travel expense data saved successfully!', type: 'success' });

        // Reset form after successful submission
        setCity('');
        setFuelRate('');
        setFuelType('');
        setExpenseCategory('');
      } else {
        setMessage({ text: 'Failed to save travel expense data', type: 'error' });
      }
    } catch (error) {
      console.error('Error saving travel expense data:', error);
      setMessage({ text: 'Error saving travel expense data', type: 'error' });
    }
  };

  return (
    <div className="admin-page-container">
      <h1 className="header">Admin Portal</h1>
      
      {/* Scrollable form container */}
      <div className="form-scroll-container">
        <form onSubmit={handleEmployeeSubmit} className="admin-form">
          {/* Display employee ID, Name, and Designation */}
          <div className="form-group">
            <label>Employee ID:</label>
            <input type="text" value={empId} readOnly />
          </div>
          <div className="form-group">
            <label>Employee Name:</label>
            <input type="text" value={empName} readOnly />
          </div>
          <div className="form-group">
            <label>Designation:</label>
            <input type="text" value={designation} readOnly />
          </div>

          {/* Expense Category Dropdown */}
          <div className="form-group">
            <label>Expense Category:</label>
            <select
              name="expenseCategory"
              value={expenseCategory}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Category</option>
              <option value="Travel Expenses - Car">Travel Expenses - Car</option>
              <option value="Travel Expenses - Bus">Travel Expenses - Bus</option>
              <option value="Travel Expenses - Auto">Travel Expenses - Auto</option>
            </select>
          </div>

          {/* City Input */}
          <div className="form-group">
  <label>City:</label>
  <select
    name="city"
    value={city}
    onChange={handleInputChange}
    placeholder="Select city"
  >
    <option value="">Select City</option>
    <option value="Hyderabad">Hyderabad</option>
    <option value="Mumbai">Mumbai</option>
    <option value="Vizag">Vizag</option>
    <option value="Delhi">Delhi</option>
    <option value="Bangalore">Bangalore</option>
    <option value="Chennai">Chennai</option>
    <option value="Kolkata">Kolkata</option>
    <option value="Pune">Pune</option>
 
  </select>
</div>


          {/* Fuel Rate Input */}
          <div className="form-group">
            <label>Fuel Rate (₹):</label>
            <input
              type="number"
              name="fuelRate"
              value={fuelRate}
              onChange={handleInputChange}
              placeholder="Enter fuel rate"
              required
            />
          </div>

          {/* Fuel Type Dropdown */}
          <div className="form-group">
            <label>Fuel Type:</label>
            <select
              name="fuelType"
              value={fuelType}
              onChange={handleInputChange}
            >
              <option value="">Select Fuel Type</option>
              <option value="Petrol">Petrol</option>
              <option value="Diesel">Diesel</option>
            </select>
          </div>

          {/* Submit Button */}
          <div className="form-actions">
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>

      {/* Success/Error Messages */}
      {message && (
        <div className={message.type === 'success' ? 'success' : 'error'}>
          {message.text}
        </div>
      )}
    </div>
  );
};

export default AdminPage;
